import { getFont, colors } from "app/theme";
import css from 'styled-jsx/css'

export default css`
.content {
  display: flex;
  flex-direction: column;
  padding: 1.25rem;
  align-items: center;
}

h3 {
  ${getFont('semiBold', 'h4')};
  display: flex;
}

h3 > :global(i) {
  color: ${colors.primary};
  margin-right: 0.5rem;
}

.content > p {
  margin: 0.5rem 0;
}

.highlight {
 ${getFont('semiBold', 'p')};
}

.content :global(button.logout) {
  margin: 1rem auto;
  max-width: 18.625rem;
  min-width: 10rem;
}

.link {
  color: ${colors.primary};
}

`
